import React from "react";
import ReusableProfileContainer from "../../directorate/ui/ReusableProfileContainer";

export default function ProfileContainer({ user }) {
  return <ReusableProfileContainer user={user} />;
}
